// Units only for a row of an additional price list: a price per piece or per running metre,
// shown in its unit menu as "€/kpl/jm" (see SIUnits.AmountOrRunningMetre)
const PRICE_LIST_UNITS = ['amount/jm'];

export default PRICE_LIST_UNITS;
